import { cilCloudDownload, cilTrash } from '@coreui/icons'
import CIcon from '@coreui/icons-react'
import { CFormInput, CInputGroup, CInputGroupText } from '@coreui/react'
import React from 'react'
import Select from 'react-select'
export default function WidgetSelector({
  selectedValue,
  options = [],
  onChange,
  placeHolder,
  viewOnly = false,
  disabled = false,
  size,
  displayValue = "",
  reloadDropdownData,
  showCloudIcon,
  displayMaxWidth,
  showFormInputView = true,
}) {
  const selectorOptions = Array.isArray(options) ? options : []
  const isExtraSmall = size === 'xs'
  const isSmall = size === 'sm' || isExtraSmall

  const selectStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    menu: (provided) => ({ ...provided, zIndex: '9999 !important' }),
    control: (base) => ({
      ...base,
      height: isExtraSmall ? 26 : isSmall ? 30 : 35,
      width: '100%',
      minHeight: isExtraSmall ? 26 : isSmall ? 30 : 35,
    }),
    dropdownIndicator: (styles) => ({
      ...styles,
      paddingTop: isExtraSmall ? 0 : isSmall ? 2 : 5,
      paddingBottom: isExtraSmall ? 0 : styles.paddingBottom,
      paddingLeft: isExtraSmall ? 6 : styles.paddingLeft,
      paddingRight: isExtraSmall ? 6 : styles.paddingRight,
    }),
    placeholder: (base) => ({
      ...base,
      marginTop: 0,
      marginBottom: isSmall ? 6 : 0,
      position: 'absolute',
      fontSize: isExtraSmall ? 12 : base.fontSize,
    }),
    valueContainer: (base) => ({
      ...base,
      paddingTop: isExtraSmall ? 0 : base.paddingTop,
      paddingBottom: isExtraSmall ? 0 : base.paddingBottom,
      paddingLeft: isExtraSmall ? 8 : base.paddingLeft,
      paddingRight: isExtraSmall ? 8 : base.paddingRight,
      fontSize: isExtraSmall ? 12 : base.fontSize,
    }),
    input: (base) => ({
      ...base,
      margin: isExtraSmall ? 0 : base.margin,
      paddingTop: isExtraSmall ? 0 : base.paddingTop,
      paddingBottom: isExtraSmall ? 0 : base.paddingBottom,
      fontSize: isExtraSmall ? 12 : base.fontSize,
    }),
    singleValue: (base) => ({
      ...base,
      fontSize: isExtraSmall ? 12 : base.fontSize,
    }),
  }

  return (
    <React.Fragment>
      {showFormInputView && +selectedValue > 0 && displayValue !== "" ? (
        <>
          <React.Fragment>
            <CInputGroup
              size={size || ''}
              style={{ width: displayMaxWidth || '100%', maxWidth: displayMaxWidth || '100%' }}
            >
              <CFormInput
                value={displayValue}
                disabled
                style={{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  minWidth: 0,
                }}
              />
              {!viewOnly && (
                <CInputGroupText
                  style={{ cursor: 'pointer' }}
                  onClick={() => onChange({ value: 0, label: '' })}
                >
                  <CIcon icon={cilTrash} alt="Remove" title="Remove" />
                </CInputGroupText>
              )}
            </CInputGroup>
          </React.Fragment>
        </>
      ) : (
        <CInputGroup
          style={{
            height: isExtraSmall ? 26 : 30,
            width: displayMaxWidth || '100%',
            maxWidth: displayMaxWidth || '100%',
          }}
        >
          <div style={{ flexGrow: 1 }}>
            <Select
              menuShouldBlockScroll
              menuPosition="fixed"
              menuPortalTarget={document.querySelector('body')}
              isClearable={false}
              styles={selectStyles}
              placeholder={placeHolder}
              isDisabled={viewOnly || disabled}
              menuPlacement="auto"
              options={selectorOptions}
              value={selectorOptions.filter(({ value }) => value === selectedValue)}
              onChange={(values) => onChange(values)}
            />
          </div>
          {showCloudIcon && (
            <>
              <CInputGroupText
                style={{ cursor: viewOnly || disabled ? 'not-allowed' : 'pointer' }}
                onClick={() => {
                  if (!viewOnly && !disabled) {
                    if (typeof reloadDropdownData === 'function') {
                      reloadDropdownData()
                    }
                  }
                }}
              >
                <CIcon icon={cilCloudDownload} alt="Remove" title="Remove" />
              </CInputGroupText>
            </>
          )}
        </CInputGroup>
      )}
    </React.Fragment>
  )
}
